var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataUpLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 32,
    viewBox: "0 0 136 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2656_39795)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4101 0.0785632L19.8851 0.00292969C19.4806 0.00292969 19.28 0.486326 19.5628 0.775706L26.1627 7.4183C26.5869 7.84908 27.1689 8.08914 27.774 8.08914H51.6709C52.0754 8.08914 52.2759 7.60245 51.9931 7.31636L45.0086 0.328482C44.8507 0.170639 44.6337 0.0785632 44.4101 0.0785632Z",
    fill: "#039EF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3967 16.6224H52.8249V31.1473C52.8249 31.6175 52.4434 31.999 51.9732 31.999H36.2151C35.8731 31.999 35.6988 31.5846 35.9389 31.3413L43.1471 24.0443H44.7584V16.6191H43.1833L44.7584 15.0439L47.6982 12.1041L48.7867 11.0156L54.3967 16.6257V16.6224Z",
    fill: "#039EF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06319 19.0432V7.95138H12.6505L28.6092 23.91H0.805661C0.529434 23.91 0.391321 24.2422 0.585337 24.4395L7.37591 31.2301C7.81656 31.6707 8.41176 31.9173 9.03327 31.9206L31.355 31.9963C31.8548 31.9963 32.335 31.7989 32.6901 31.4471L39.5432 24.6171C39.8753 24.2849 39.8753 23.7456 39.5432 23.4135L16.9551 0.822103C16.4289 0.295957 15.7153 0 14.9721 0H0.851699C0.381456 0 0 0.381456 0 0.851699V19.0465C0 19.5167 0.378167 19.8982 0.851699 19.8982H7.21478C7.68502 19.8982 8.06647 19.5167 8.06647 19.0465L8.06319 19.0432Z",
    fill: "#039EF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1444 26.428C60.6054 26.428 59.6123 25.6091 59.6123 23.8729V23.7709C59.6123 22.0346 60.6745 21.2158 62.3088 21.2158C62.8349 21.2158 63.3644 21.275 63.7721 21.3967V22.13C63.3249 21.9919 62.8843 21.9327 62.3285 21.9327C61.0987 21.9327 60.5199 22.5312 60.5199 23.7841V23.8498C60.5199 25.1093 61.0461 25.7111 62.151 25.7111C62.5258 25.7111 62.8317 25.6881 63.1112 25.6289V24.1655H61.8583L62.0392 23.4487H64.0155V26.1583C63.3052 26.349 62.8317 26.428 62.1411 26.428V26.4312L62.1444 26.428Z",
    fill: "#001724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3292 21.249H71.2302L73.3381 26.3822H72.3417L71.9602 25.3858H69.5958L69.2078 26.3822H68.2114L70.3259 21.249H70.3226H70.3292ZM71.6971 24.6755L70.783 22.2947L69.8523 24.6755H71.6971Z",
    fill: "#001724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6262 21.2588L80.4216 25.2641L82.2105 21.2588H83.2727V26.3821H82.3717V22.778L80.7669 26.3821H80.0796L78.4782 22.778V26.3821H77.5771V21.2588H78.6327H78.6262Z",
    fill: "#001724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7836 21.2588V26.3821H87.876V21.4857L88.7836 21.2588Z",
    fill: "#001724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1506 21.2588L96.801 24.876V21.2588H97.7086V26.3821H96.926L94.2821 22.7583V26.3821H93.3745V21.2588H94.1506Z",
    fill: "#001724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.677 26.428C103.138 26.428 102.145 25.6091 102.145 23.8729V23.7709C102.145 22.0346 103.207 21.2158 104.841 21.2158C105.367 21.2158 105.897 21.275 106.304 21.3967V22.13C105.857 21.9919 105.417 21.9327 104.861 21.9327C103.631 21.9327 103.052 22.5312 103.052 23.7841V23.8498C103.052 25.1093 103.582 25.7111 104.683 25.7111C105.058 25.7111 105.364 25.6881 105.643 25.6289V24.1655H104.391L104.575 23.4487H106.551V26.1583C105.841 26.349 105.367 26.428 104.677 26.428Z",
    fill: "#001724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0039 5.57324H59.6089V16.0008H69.0039C70.921 16.0008 72.4896 14.4388 72.4896 12.5151V9.05896C72.4896 7.13195 70.9144 5.57324 69.0039 5.57324ZM62.677 8.64133H68.7836C69.1354 8.64133 69.4215 8.92742 69.4215 9.27928V12.298C69.4215 12.6466 69.1354 12.936 68.7836 12.936H62.677V8.64133Z",
    fill: "#001724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.3454 5.57324H76.8173L72.4897 16.0008H75.8078L78.8627 8.64133V7.87513H79.2968V8.64133L82.3517 16.0008H85.673L81.3454 5.57324Z",
    fill: "#001724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.0186 5.57324V8.64133H88.9216V16.0008H91.9897V8.64133H96.896V5.57324H84.0186Z",
    fill: "#001724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.46 8.26609C135.308 7.63472 134.989 7.05925 134.529 6.59887C134.065 6.1352 133.49 5.81623 132.858 5.66825C132.602 5.60577 132.332 5.57617 132.066 5.57617H122.671V16.0037H125.739V13.5506H132.066C132.184 13.5506 132.309 13.544 132.428 13.5341C132.576 13.521 132.72 13.4947 132.858 13.4618C133.49 13.3138 134.065 12.9915 134.529 12.5312C134.989 12.0708 135.308 11.4953 135.456 10.8639V10.8574L135.46 10.8475C135.515 10.591 135.548 10.3312 135.548 10.0681V9.06518C135.548 8.79553 135.515 8.53245 135.456 8.27267L135.46 8.26609ZM125.736 8.64097H131.846C132.197 8.64097 132.484 8.92706 132.484 9.27892V9.84453C132.484 10.1964 132.197 10.4792 131.846 10.4792H125.739V8.64097H125.736Z",
    fill: "#001724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.448 5.57324V5.88235L118.445 12.9327H112.342C111.99 12.9327 111.704 12.6466 111.704 12.298V5.57324H108.639V13.0379C108.754 13.7976 109.119 14.5111 109.675 15.0439C110.231 15.5832 110.961 15.9186 111.727 15.9975H111.743L117.64 16.0008L118.518 15.0307V16.0008H121.517V5.57324H118.452H118.448Z",
    fill: "#001724"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.019 5.57324H99.4906L95.1631 16.0008H98.4811L101.536 8.64133V7.87513H101.967V8.64133L105.025 16.0008H108.343L104.019 5.57324Z",
    fill: "#001724"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2656_39795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135.552,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataUpLogo);
export default __webpack_public_path__ + "static/media/DataUpLogo.1a3c4cc0ec1ef0df1b02b0843b9fa3eb.svg";
export { ForwardRef as ReactComponent };